import { render, staticRenderFns } from "./OnboardingSupervisionNotice.vue?vue&type=template&id=6081496a&scoped=true&"
import script from "./OnboardingSupervisionNotice.vue?vue&type=script&lang=js&"
export * from "./OnboardingSupervisionNotice.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSupervisionNotice.vue?vue&type=style&index=0&id=6081496a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081496a",
  null
  
)

export default component.exports